export default __webpack_public_path__ + "10a233c6e4e42deb4cd1b3289645177a.png";